module.exports = __webpack_public_path__ + "static/media/whiteLogo.85a0c6e6.png";